import { render, staticRenderFns } from "./ImportViewImportedItems.vue?vue&type=template&id=1bc8173d"
import script from "./ImportViewImportedItems.vue?vue&type=script&lang=js"
export * from "./ImportViewImportedItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports